import { Button, Form, Input, InputNumber, Popconfirm, Radio, Select, Space, Tag } from "antd";
import { colorAreas, colorCurrency } from "../schemesColors";
import { trimSpaces } from "../../helpers/textTransform";
import { jsonDataStatusSimulation } from "../initStore/initSimulation";
import { DeleteFilled, EditFilled, SaveOutlined, CloseOutlined, WarningTwoTone } from "@ant-design/icons";
import { teamAreasByFormHoursAdd } from "../initStore/initUser";
import { convertToFormat } from "../../helpers/operationMath";

//* inputs para el formulario de editar en la tabla
const inputs = {
    name: {
        component: <Input size="large" style={{ width: "100%" }} />,
        rules: [
            {
                required: true,
                message: "Nombre",
            },
        ],
        name: "name",
    },
    price: {
        component: <InputNumber size="large" min={0} style={{ width: "100%" }} />,
        rules: [],
        name: ["price"],
    },
    currency: {
        component: (
            <Radio.Group>
                <Radio.Button value="MXN">MXN</Radio.Button>
                <Radio.Button value="USD">USD</Radio.Button>
            </Radio.Group>
        ),
        rules: [],
        name: ["currency"],
    },
    link: {
        component: <Input size="large" style={{ width: "100%" }} />,
        rules: [],
        name: ["link"],
    },
    status: {
        component: (
            <Select
                showSearch
                placeholder="selecciona un estatus"
                style={{
                    width: "100%",
                }}
            >
                {Object.values(jsonDataStatusSimulation)
                    .map((item) => item.name)
                    .map((statu) => (
                        <Select.Option key={`${statu}-status-table`} value={statu}>
                            {statu}
                        </Select.Option>
                    ))}
            </Select>
        ),
        rules: [
            {
                required: true,
                message: "selecciona un estado",
            },
        ],
        name: ["status"],
    },
    area: {
        component: (
            <Select
                showSearch
                placeholder="selecciona un area"
                style={{
                    width: "100%",
                }}
            >
                {teamAreasByFormHoursAdd().map((area) => (
                    <Select.Option key={`${area}-areas`} value={area}>
                        {area}
                    </Select.Option>
                ))}
            </Select>
        ),
        rules: [
            {
                required: true,
                message: "selecciona una area",
            },
        ],
        name: ["area"],
    },
    outsourceHours: {
        component: <InputNumber size="large" min={0} style={{ width: "100%" }} />,
        rules: [],
        name: ["outsourceHours"],
    },
    budget: {
        component: <InputNumber size="large" min={0} style={{ width: "100%" }} />,
        rules: [],
        name: ["budget"],
    },
};

//* metodo para editar

const EditableCell = ({ editing, inputIteam, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    if (editing) {
        return (
            <td {...restProps}>
                <Form.Item
                    name={inputIteam.name}
                    style={{
                        margin: 0,
                    }}
                    rules={inputIteam.rules}
                >
                    {inputIteam.component}
                </Form.Item>
            </td>
        );
    }
    return <td {...restProps}>{children}</td>;
};

//* props de tabla general
const propsColumns = () => {
    return {
        components: {
            body: {
                cell: EditableCell,
            },
        },
        rowClassName: "editable-row",
        scroll: { x: "100%", y: null },
    };
};

//* columnn general

const mergedColumns = (
    action = {
        editAction: () => { },
        deleteAction: () => { },
        isEditing: () => { },
        cancelSave: () => { },
        editSave: () => { },
    },
    values = {
        editingKey: "",
    }
) => {
    const column = [
        {
            title: "Proveedor",
            dataIndex: "name",
            key: "name",
            render: (text) => <span className="block w-32">{text}</span>,
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
            editable: true,
        },
        {
            title: "Área",
            dataIndex: "area",
            key: "area",
            render: (text) => {
                let color = "#ccc";
                const colorSchema = colorAreas.find((col) => trimSpaces(col.name) === trimSpaces(text));
                if (colorSchema) {
                    color = colorSchema.color;
                }
                return (
                    <div className="flex items-center gap-2 w-40">
                        <div className="w-fit">
                            <div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }}></div>
                        </div>
                        <span className="font-semibold text-xs">{text}</span>
                    </div>
                );
            },
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
            editable: true,
        },
        {
            title: "Hrs. a Tercerizar",
            dataIndex: "outsourceHours",
            key: "outsourceHours",
            render: (_, record) => {
                let color = "#ccc";
                if (jsonDataStatusSimulation.Simulation.name === record.status) {
                    color = jsonDataStatusSimulation.Simulation.color;
                }
                return (
                    <div className="w-32">
                        <Tag style={{ color: "black", border: "1px solid", borderColor: color, backgroundColor: `${color}33` }}>
                            {record.outsourceHours}
                        </Tag>
                    </div>
                );
            },
            editable: true,
        },
        {
            title: "Presupuesto Real",
            dataIndex: "realmoney",
            key: "realmoney",
            width: 150,
            render: (text) => <span className="block w-24">{convertToFormat(text)}</span>,
        },
        {
            title: () => (
                <div>
                    <span>Presupuesto Inicial (</span>
                    <span className="text-green-500">0.75</span>
                    <span>)</span>
                </div>
            ),
            dataIndex: "budgetInit",
            key: "budgetInit",
            width: 150,
            render: (text) => {
                return <span className="block w-24">{convertToFormat(text)}</span>;
            },
        },
        {
            title: () => (
                <div>
                    <span>Presupuesto Máximo (</span>
                    <span className="text-red-500">1.1</span>
                    <span>)</span>
                </div>
            ),
            dataIndex: "budgetMax",
            key: "budgetMax",
            width: 150,
            render: (text) => {
                return <span className="block w-24">{convertToFormat(text)}</span>;
            },
        },
        {
            title: "Moneda",
            dataIndex: "currency",
            key: "currency",
            render: (text) => {
                let color = "#ccc";
                const find = colorCurrency.find((col) => col.name === text);
                if (find) {
                    color = find.color;
                }
                return (
                    <div className="w-32">
                        <Tag style={{ color: "black", border: "1px solid", borderColor: color, backgroundColor: `${color}33` }}>{text}</Tag>
                    </div>
                );
            },
            editable: true,
        },
        {
            title: "Cotización Proveedor",
            dataIndex: "budget",
            key: "budget",
            render: (_, record) => {
                const alert = record.budget > record.budgetMax;
                return (
                    <span className="flex items-center gap-1 w-24">
                        {record.budget} {alert && <WarningTwoTone twoToneColor="#EF4444" />}
                    </span>
                );
            },
            editable: true,
        },
        {
            title: "Link de cotización",
            dataIndex: "link",
            key: "link",
            render: (text) => <span className="block w-24">{text}</span>,
            editable: true,
        },
        {
            title: "Estatus",
            dataIndex: "status",
            key: "status",
            render: (text) => {
                let color = Object.values(jsonDataStatusSimulation).find((status) => status.name === text)?.color || "#ccc";
                return (
                    <Tag color={color} className="py-[2px] px-3">
                        {text}
                    </Tag>
                );
            },
            editable: true,
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => {
                const editable = action.isEditing(record);
                if (editable) {
                    return (
                        <Space size="middle">
                            <Button
                                type="text"
                                icon={<SaveOutlined />}
                                onClick={() => {
                                    action.editSave(0);
                                }}
                            />
                            <Popconfirm title="Cancelar edición" onConfirm={action.cancelSave}>
                                <Button type="text" icon={<CloseOutlined />} />
                            </Popconfirm>
                        </Space>
                    );
                }
                return (
                    <Space size="middle">
                        <Button
                            type="text"
                            disabled={values.editingKey !== ""}
                            icon={<EditFilled />}
                            onClick={() => {
                                action.editAction(record);
                            }}
                        />
                        <Popconfirm
                            title={`Eliminar`}
                            onConfirm={() => {
                                action.deleteAction(record);
                            }}
                        >
                            <Button disabled={values.editingKey !== ""} type="text" icon={<DeleteFilled />} />
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];
    const merge = column.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => {
                return {
                    record,
                    inputIteam: inputs[col.dataIndex],
                    editing: action.isEditing(record),
                };
            },
        };
    });
    return merge;
};

//* metodo que retorne el hook

export const columnsProviderCalculation = (
    action = {
        editAction: () => { },
        deleteAction: () => { },
        isEditing: () => { },
        cancelSave: () => { },
        editRow: () => { },
    },
    values = {
        editingKey: "",
        editingExpandle: "",
        formProviderExplandle: null,
    }
) => {
    const columns = mergedColumns(
        {
            editAction: action.editAction,
            deleteAction: action.deleteAction,
            isEditing: action.isEditing,
            cancelSave: action.cancelSave,
            editSave: action.editRow,
        },
        {
            editingKey: values.editingKey,
        }
    );
    const props = propsColumns();
    return {
        columns,
        props,
    };
};
